const doc = [({"da":({"js":({"admin":({"activity_participants":({"requested_unregister":({"requested_unregister":"Anmod om afmeldelse"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;